module.exports = __webpack_public_path__ + "iPhone_X.svg?f0d1933591f243d93a776f79edf8122c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/iPhone_X.svg
// module id = 231
// module chunks = 0